import { useCallback, useEffect, useState } from 'react';
import { getVerifiedPlusStatus } from 'api/verifiedPlus';
import { TVerifiedPlusStatus } from 'types/verifiedPlus';

const useJoinVerifyPlusStatus = (): [TVerifiedPlusStatus | undefined, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<TVerifiedPlusStatus>();

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getVerifiedPlusStatus();
            if (res && !res.error) {
                setData(res.data?.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useJoinVerifyPlusStatus;
